'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Bike, Calendar, Clock, Footprints, Hammer, MapPin, Mountain, Settings, Shield, ShieldCheck, Snowflake, Sparkles, Store, Wrench, Users } from 'lucide-react';
import faqsData from '@/content/faqs.json';
import faqsSummerData from '@/content/faqs-summer.json';
import faqsWinterData from '@/content/faqs-winter.json';
import faqsAtelierSummerData from '@/content/faqs-atelier-summer.json';
import faqsAtelierWinterData from '@/content/faqs-atelier-winter.json';
type FAQItem = {
  id: string;
  icon: string;
  season: 'summer' | 'winter' | 'both';
  question: {
    en: string;
    fr: string;
    nl: string;
    es: string;
    it: string;
  };
  answer: {
    en: string;
    fr: string;
    nl: string;
    es: string;
    it: string;
  };
};
type FAQsHomeProps = {
  locale: string;
  season?: 'summer' | 'winter' | 'atelier-summer' | 'atelier-winter';
};
export default function FAQsHome(t0) {
  const $ = _c(31);
  const {
    locale: t1,
    season
  } = t0;
  const locale = t1 === undefined ? "en" : t1;
  const selectedData = season === "atelier-summer" ? faqsAtelierSummerData : season === "atelier-winter" ? faqsAtelierWinterData : season === "summer" ? faqsSummerData : season === "winter" ? faqsWinterData : faqsData;
  const faqItems = selectedData.faqs as FAQItem[];
  const title = selectedData.metadata.title[locale as keyof typeof selectedData.metadata.title] || selectedData.metadata.title.en;
  const subtitle = selectedData.metadata.subtitle[locale as keyof typeof selectedData.metadata.subtitle] || selectedData.metadata.subtitle.en;
  let t2;
  let t3;
  if ($[0] !== faqItems || $[1] !== locale) {
    let t4;
    if ($[4] !== locale) {
      t4 = item => ({
        "@type": "Question",
        name: item.question[locale as keyof typeof item.question] || item.question.en,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer[locale as keyof typeof item.answer] || item.answer.en
        }
      });
      $[4] = locale;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    const faqJsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map(t4)
    };
    t3 = "application/ld+json";
    t2 = JSON.stringify(faqJsonLd);
    $[0] = faqItems;
    $[1] = locale;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = {
      __html: t2
    };
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <script type={t3} dangerouslySetInnerHTML={t4} />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== title) {
    t6 = <h2 className="text-4xl md:text-5xl font-bold font-[family-name:var(--font-bebas-neue)]">{title}</h2>;
    $[11] = title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== subtitle) {
    t7 = <p className="text-foreground/90 mt-4 text-base">{subtitle}</p>;
    $[13] = subtitle;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="lg:w-1/3"><div className="sticky top-24">{t6}{t7}</div></div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== faqItems || $[19] !== locale) {
    let t10;
    if ($[21] !== locale) {
      t10 = item_0 => {
        const question = item_0.question[locale as keyof typeof item_0.question] || item_0.question.en;
        const answer = item_0.answer[locale as keyof typeof item_0.answer] || item_0.answer.en;
        const iconMap = {
          "bike": Bike,
          "clock": Clock,
          "map-pin": MapPin,
          "mountain": Mountain,
          "settings": Settings,
          "shield": Shield,
          "shield-check": ShieldCheck,
          "sparkles": Sparkles,
          "store": Store,
          "wrench": Wrench,
          "tool": Hammer,
          "users": Users,
          "calendar": Calendar,
          "snowflake": Snowflake,
          "shoe-prints": Footprints
        };
        const IconComponent = iconMap[item_0.icon] || Sparkles;
        return <AccordionItem key={item_0.id} value={item_0.id} className="bg-background/95 backdrop-blur-sm shadow-sm hover:shadow-md transition-shadow rounded-xl border border-border/50 px-5 overflow-hidden last:border-b"><AccordionTrigger className="cursor-pointer items-center py-5 hover:no-underline group"><div className="flex items-center gap-4"><div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-[url('/leather.jpg')] bg-cover bg-center border border-[#2a1f10]/50"><IconComponent className="size-5 text-black" /></div><span className="text-lg font-bold text-left leading-snug">{question}</span></div></AccordionTrigger><AccordionContent className="pb-6"><div className="pl-12 pr-4"><p className="text-base text-foreground/90 leading-relaxed">{answer}</p></div></AccordionContent></AccordionItem>;
      };
      $[21] = locale;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    t9 = faqItems.map(t10);
    $[18] = faqItems;
    $[19] = locale;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <div className="lg:w-2/3"><Accordion type="single" collapsible={true} className="w-full space-y-3">{t9}</Accordion></div>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8) {
    t11 = <section className="py-16 md:py-24"><div className="mx-auto max-w-6xl px-4 md:px-6"><div className="flex flex-col gap-10 lg:flex-row lg:gap-16">{t8}{t10}</div></div></section>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t5) {
    t12 = <>{t5}{t11}</>;
    $[28] = t11;
    $[29] = t5;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}